import { call, put } from "redux-saga/effects";
import { authApi } from "@services/api";
import { codeValidatorActions } from "../slices";
import { showFailureToast, showSuccessToast } from "@helpers";
import { has } from "lodash";

function* codeValidatorWorker({ payload }) {
  try {
    yield put(codeValidatorActions.pending());
    const response = yield call(authApi.codeValidator, payload);
    yield put(codeValidatorActions.success(response));
    // TODO: handle callback | onSuccess
    showSuccessToast("Verification code has been sent to your email.");
    if (has(payload, "onSuccess")) {
      payload.onSuccess();
    }
  } catch (error) {
    yield put(codeValidatorActions.failure(error));
    // TODO: handle callback | onFailure
    showFailureToast("Something went wrong, we can't connect to your email.");
  }
}

export { codeValidatorWorker };
